export enum EnumClaimRequestStatus {
  DRAFT = "DRAFT",
  WAITING = "WAITING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  CANCELED = "CANCELED",
  APPROVED_WAITING_DOCS = "APPROVED_WAITING_DOCS",
}
